import React, { useState } from 'react';
import { FaPen, FaTrash } from 'react-icons/fa';
import {
  IconButton,
  Text,
  Tr,
  Td,
  HStack,
  Tag,
  useToast,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import auth from '../../../../apis/auth';
import Restricted from '../../../../components/Restricted';

interface Props {
  user: any;
  onDelete?: (userId: any) => void;
  onEditClick?: (user: any) => void;
}

const Item: React.FC<Props> = ({ user, onDelete, onEditClick }) => {
  const toast = useToast();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleUserDelete = async (userId: string) => {
    try {
      setLoading(true);
      if (!window.confirm(t('askDeleteUser'))) {
        return;
      }
      await auth.delete(`users/${userId}`);
      if (onDelete) {
        onDelete(userId);
      }
      toast({
        title: t('success'),
        description: t('deletedUser'),
        status: 'success',
        position: 'top-right',
      });
    } catch (err: any) {
      toast({
        title: 'Opss!!',
        description: err?.response?.data?.message || t('generalError'),
        status: 'error',
        position: 'top-right',
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <Tr
      bg="#FFFFFF"
      border="1px solid #FFFFFF"
      borderRadius="14px"
      height="61px"
    >
      <Td>
        {user?.email}
        {!!user?.name && (
          <Text fontSize="sm" color="gray.400">
            {user?.name}
          </Text>
        )}
      </Td>
      <Td>
        {user.cpf
          ? user.cpf.replace(/(^\d{3})(\d{3})(\d{3})(\d{2}$)/, '$1.$2.$3-$4')
          : '-'}
      </Td>
      <Td>
        {user?.roles?.length > 0 ? (
          <Tag variant="solid" colorScheme="blue" size="sm">
            {user?.roles?.map((role: any, index: number) => {
              if (index === user?.roles?.length - 1) {
                return role;
              }
              return `${role} | `;
            })}
          </Tag>
        ) : (
          <Tag variant="solid" colorScheme="blue" size="sm">
            App
          </Tag>
        )}
      </Td>
      <Td>
        <HStack>
          <Restricted allowedPermissions={['update_user']}>
            <IconButton
              color="#CECECE"
              aria-label="edit-user"
              rounded="md"
              icon={<FaPen size={17} />}
              size="xs"
              colorScheme="#FFFFFF"
              isLoading={loading}
              onClick={() => {
                if (onEditClick) {
                  onEditClick(user);
                }
              }}
            />
          </Restricted>
          <Restricted allowedPermissions={['delete_user']}>
            <IconButton
              color="#FF6565"
              aria-label="delete-user"
              rounded="md"
              icon={<FaTrash size={17} />}
              size="xs"
              colorScheme="#FFFFFF"
              isLoading={loading}
              onClick={() => {
                handleUserDelete(user?.id);
              }}
            />
          </Restricted>
        </HStack>
      </Td>
    </Tr>
  );
};

export default Item;
